import {
  DragEndEvent,
  DragStartEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { useState } from 'react';
import { UseCatalogSectionsDndParams } from './useCatalogSectionsDnd.types';

const DRAG_ACTIVATION_DELAY_MS = 200;
const DRAG_ACTIVATION_TOLERANCE_PX = 5;

export const useCatalogSectionsDnd = ({ orderedIds, onReorder }: UseCatalogSectionsDndParams) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: DRAG_ACTIVATION_DELAY_MS,
        tolerance: DRAG_ACTIVATION_TOLERANCE_PX,
      },
    }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );

  const handleDragStart = ({ active }: DragStartEvent) => setActiveId(String(active.id));

  const handleDragCancel = () => setActiveId(null);

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    setActiveId(null);

    if (!over || active.id === over.id) {
      return;
    }

    const fromIndex = orderedIds.indexOf(String(active.id));
    const toIndex = orderedIds.indexOf(String(over.id));

    if (fromIndex === -1 || toIndex === -1) {
      return;
    }

    onReorder({ fromIndex, toIndex });
  };

  return { sensors, activeId, handleDragStart, handleDragCancel, handleDragEnd };
};
